export default __webpack_public_path__ + "static/media/CA.6c286579.webp";